import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { FiLock } from 'react-icons/fi';

import Input from '../../components/Input';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';

import { Container, Content, Background } from './styles';
import Loading from '../../components/Loading';

interface SignInFormData {
  email: string;
  password: string;
  clinica: string;
}

const SignInBloqueado: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const { signIn } = useAuth();
  const { imagensClinica, loading: carregando } = useClinica();

  // useEffect(() => {
  //   buscaClinicas();
  // }, [buscaClinicas]);

  const logo =
    imagensClinica.find(img => img.nome === 'logo')?.arquivo_url || '';

  const CliDrSaude = !imagensClinica.find(img => img.nome === 'saopaulo');

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string().required('Senha obrigatória'),
          clinica: Yup.string().required('Clínica obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: 'suporte@riosulweb.com.br',
          password: data.password,
          codClinica: Number(data.clinica),
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
          return;
        }
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [signIn],
  );

  return (
    <Container>
      {carregando && <Loading />}
      <Content>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <h1>Login</h1>
          <p>Área de acesso restrito</p>
          <Input
            icon={FiLock}
            name="password"
            type="password"
            required
            placeholder="Senha"
            textUppercase={false}
          />
          <br />
          <Input name="clinica" type="number" required />

          <Button loading={loading} type="submit" className="mt-2">
            Entrar
          </Button>

          <br />
        </Form>
      </Content>
      {imagensClinica.length > 0 && (
        <Background CliDrSaude={CliDrSaude}>
          <div>
            <img src={logo} alt="Logo Clinica" />
          </div>
        </Background>
      )}
    </Container>
  );
};

export default SignInBloqueado;
